import { render } from "./Orcamento.vue?vue&type=template&id=a4f5de76"
import script from "./Orcamento.vue?vue&type=script&lang=js"
export * from "./Orcamento.vue?vue&type=script&lang=js"
script.render = render

export default script